// import React from "react";
// import { InlineWidget } from "react-calendly";
// import "../../styles.css";

// const Booking = () => {
//   return (
//     <section className="container py-5">
//       <InlineWidget url="https://calendly.com/bansahassociates/immigration-consultation" />
//     </section>
//   );
// };

// export default Booking;

import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
import "../../styles.css";

export default function Booking() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "30min" });
      cal("ui", {
        theme: "light",
        cssVarsPerTheme: { light: { "cal-brand": "#0e4b82" } },
        hideEventTypeDetails: false,
        layout: "month_view",
      });
    })();
  }, []);
  return (
    <section className="container py-5" style={{ height: "100vh" }}>
      <Cal
        namespace="30min"
        calLink="bansahandassociates/30min"
        style={{
          width: "100%",
          height: "100%",
          overflow: "auto",
          marginTop: "5rem",
          marginBottom: "5rem",
        }}
        config={{ layout: "month_view", theme: "light" }}
      />
    </section>
  );
}
